{
  "translation": {
    "button": {
      "ok": "Ok",
      "cancel": "Annuler",
      "login": "Login",
      "logout": "Logout",
      "save": "Sauvegarder",
      "manageoptions": "ManageOptions",
      "manageproduct": "Gérer le produit",
      "resetAll": "Tout réinitialiser aux valeurs du produit",
      "revert": "Revenir",
      "statusButton": "Actif/Inactif",
      "add": "Ajouter",
      "selectCategory": "Sélectionnez une catégorie",
      "close": "Fermer",
      "publish": "Publier",
      "publishProductData": "Envoyer à Sofon",
      "export": "Exporter",
      "new": "Nouveau",
      "delete": "Supprimer",
      "refresh": "Rafraîchir",
      "create": "Créer",
      "proCosExport": "ProCos Exportation",
      "pcsExport": "PCS Exportation",
      "submit": "Soumettre"
    },
    "tooltip": {
      "edit": "Modifier",
      "view": "Voir",
      "reset": "Réinitialiser",
      "publishProductDataEnabled": "Les données présentes dans le cadre du Master et publiées seront partagées.",
      "publishProductDataDisabled": "Désactivé car le produit est inactif dans Master."
    },
    "footer": {
      "env": "Env",
      "release": "R",
      "sprint": "SP",
      "build": "Construire",
      "branch": "Branche",
      "date": "Date"
    },
    "labels": {
      "selectCategoryType": "Sélectionnez un type de catégorie",
      "searchMultiNumericCategory": "Rechercher une catégorie multi-numérique",
      "addCategory": "ajouter une catégorie",
      "search": "Recherche",
      "recordsPerPage": "Enregistrements",
      "workItem": "Élément de travail",
      "searchproduct": "Rechercher un produit",
      "language": "Choisir la langue",
      "feature": "Fonctionnalité",
      "option": "Option",
      "type": "Taper",
      "reset": "Réinitialiser aux valeurs du produit",
      "flag": "Drapeau",
      "code": "Code",
      "country": "Pays",
      "quote": "Demande de prix",
      "saveStatus": "Enregistrer",
      "quoteSymbol": "Q",
      "expandAll": "Développer tout",
      "collapseAll": "Tout réduire",
      "masterProperties": "Propriétés principales",
      "productProperties": "Propriétés du produit",
      "categories": "Catégories",
      "unassigned": "Non attribué",
      "assigned": "Assignée",
      "defaultAssignment": "Attribué par défaut",
      "refresh": "Rafraîchir",
      "procos": "ProCoS",
      "pdm": "PDM",
      "product": "Produit",
      "RuleCreationFailed": "Toutes les créations de règles ont échoué.",
      "standard": "Standard",
      "multiNumeric": "Multi-numérique",
      "multiNumericManagement": "Gestion multi-numérique",
      "manage": "Gérer",
      "yes": "Oui",
      "no": "Non",
      "isActive": "Actif",
      "isLocal": "Est local",
      "name": "Nom",
      "status": "Statut",
      "others": "Autres",
      "multiNumericAction": "{{Action}} Fonction multinumérique",
      "createdOn": "Créé le",
      "modifiedOn": "Modifié le",
      "createdBy": "Créé par",
      "modifiedBy": "Modifié par",
      "active": "Actif",
      "inActive": "Inactif",
      "propertyCode": "Code de propriété",
      "associationType": "Type d'association",
      "featureCode": "Code de fonctionnalité",
      "optionCode": "Code d'option",
      "action": "Action",
      "oldValue": "Ancienne valeur",
      "newValue": "Nouvelle valeur",
      "startDate": "Date de début",
      "endDate": "Date de fin",
      "history": "Historique",
      "properties": {
        "ACO": "Code alternatif",
        "AGC": "Groupe d'articles",
        "ASC": "Codes associés",
        "CHT": "Type de canal",
        "CON": "Consommateur",
        "DVI": "Livraison via",
        "GRD": "Est gardé",
        "HDE": "Cacher",
        "ICO": "Catalogue réservé aux enfants",
        "IPR": "Le prix est-il pertinent",
        "ITY": "Type d'article",
        "MLE": "Longueur maximale",
        "OPT": "Est optionnel",
        "ORI": "Instructions de commande",
        "PAT": "Type de produit",
        "PCFD": "Imprimer sur CFD",
        "PMA": "Disponibilité du marché ProCos",
        "RCI": "Identifiant du catalogue de sortie",
        "REO": "Est en lecture seule",
        "RMA": "Règles disponibles sur le marché",
        "RTY": "Type de référence",
        "SCN": "Nom de la caractéristique SAP",
        "SCV": "Valeur de la caractéristique SAP",
        "SRI": "Le service est-il pertinent?",
        "ERO": "Organisation de responsabilité de l'ingénierie"
      },
      "columns": "Columns",
      "filters": "Filters",
      "selectAll": "Tout sélectionner",
      "consumers": "Consommateurs"
    },
    "home": {
      "header": "Sélection du modèle de produit"
    },
    "dialogBox": {
      "error": "Erreur",
      "save": "Enregistrer",
      "reset": "Réinitialiser",
      "revert": "Revenir",
      "unsavedChanges": "Avertissement - Modifications non enregistrées",
      "success": "succès",
      "delete10Items": "Seuls 10 enregistrements peuvent être supprimés à la fois",
      "confirm": "Confirmer {{action}}"
    },
    "messages": {
      "logoutMessage": "L’utilisateur est déconnecté. Veuillez vous reconnecter à l’application.",
      "unauthenticated": "User is not logged in. Please login. If problem persists, please contact your administrator.",
      "browserNotSupported": "Browser not supported",
      "browserNotSupportedMessage": "You are using a browser or browser version that is not officially supported.<1/><1/>You can continue to use the application or use one of the latest version of the supported browser for best experience.",
      "supportedBrowsers": "Supported browsers: ",
      "downloadMessage": "{{filename}} a été téléchargé avec succès",
      "noSearchRecords": "Aucun enregistrement trouvé pour '{{searchValue}}'",
      "noDataFound": "Aucune donnée trouvée.",
      "noDataFoundForCriteria": "Aucune donnée disponible pour les critères spécifiés.",
      "error": {
        "403": "Vous n'y avez pas accès. Veuillez contacter l'administrateur.",
        "ERR_NETWORK": "Erreur réseau : la requête n’a pas pu être traitée, essayez de sauvegarder les données à nouveau.",
        "WiInvalid": "L'élément de travail sélectionné est invalide ! Veuillez en sélectionner un autre ou en créer un nouveau.",
        "invalidWorkItemId": "Identifiant de l'élément de travail invalide : doit être un nombre >= 1",
        "E_RUL_VAL_101": "Données ProCos introuvables",
        "E_PRD_VAL_101": "Consommateurs non valides : {{consumers}}",
        "fetchPropertyAssociations": "Une erreur s'est produite. Impossible de récupérer les associations de propriétés !"
      },
      "http": {
        "404": "Ressource introuvable.",
        "401": "Votre session a expiré. Veuillez vous reconnecter.",
        "500": "Une erreur s'est produite Veuillez réessayer plus tard",
        "204": "Aucune modification à enregistrer.",
        "400": "Données invalides.",
        "403": "Vous n'avez pas accès. Veuillez contacter l'administrateur."
      },
      "pdm": {
        "noPropertiesFound": "Aucune propriété trouvée",
        "noPropertyAssociationFound": "Aucune association de propriétés trouvée."
      },
      "feature": {
        "confirmDelete": "Etes-vous sûr de vouloir supprimer?"
      },
      "category": {
        "selectCategory": "Veuillez sélectionner une catégorie",
        "categoryAlreadyExist": "Une séquence ou une catégorie existe déjà",
        "confirm": "Confirmer",
        "confirmDelete": "Êtes-vous sûr de vouloir supprimer la catégorie ?",
        "confirmCleanEmptySection": "Les sections sans fonctionnalité seront supprimées.",
        "unsavedChanges": "Avertissement - Modifications non enregistrées",
        "discardChanges": "Les modifications non enregistrées seront ignorées. Voulez-vous continuer ?",
        "savedSuccessfully": "Vue principale enregistrée avec succès",
        "noFeatureAssigned": "Aucune fonctionnalité n’est attribuée !",
        "saveToremoveObsoleteFeature": "Il y a des fonctionnalités obsolètes et il doit économiser",
        "multiNumericWarning": "Seules les familles de fonctionnalités numériques peuvent être ajoutées.",
        "multiNumericReadError": "Fonctionnalité introuvable",
        "multiNumericMinValidationError": "Minimum de {{minLength}} caractères requis",
        "multiNumericMaxValidationError": "Nombre maximal de caractères autorisés : {{maxLength}}",
        "searchLimitWarning": "{{limit}}/{{total}} résultats sont affichés. Affinez vos critères de recherche pour affiner votre recherche.",
        "inValidCategoryDrag": "ne peut pas descendre à cette position"
      },
      "submit": {
        "general": "Les modifications sont enregistrées avec succès !",
        "new": "Souhaitez-vous enregistrer les informations ProCoS dans <1>Nouvel élément de travail</1> ?",
        "exist": "Souhaitez-vous enregistrer les informations ProCoS dans le WorkItem - <1>{{workItemName}} </1> ?",
        "allMarketsRemoved": "Utilisez le menu déroulant 'Statut' pour marquer le produit comme inactif.",
        "success": "Modifications enregistrées avec succès dans WorkItem - <1>{{workItemName}} </1>",
        "error": "Échec de la sauvegarde !",
        "reset": "Voulez-vous réinitialiser les ProCos de la Fonctionnalité/Option avec les ProCos au niveau du produit ?",
        "resetAll": "Voulez-vous réinitialiser les ProCos de toutes les fonctionnalités/options avec les ProCos au niveau du produit ?",
        "revert": "Souhaitez-vous annuler vos modifications sur l'élément de travail actuel - <1>{{workItemName}} </1> ?",
        "failedEffectivities": "Échoué (Actif / Inactif) : Les fonctionnalités / options suivantes n'ont pas pu être traitées.",
        "AllEffectivityFailed": "Toutes les mises à jour d'effectivité ont échoué.",
        "RulesSaved": "Règles enregistrées avec succès.",
        "EffectivitySaved": "Effectivité enregistrée avec succès.",
        "DeleteRequest": "Échec de la demande de suppression",
        "DeleteRequestSuccess": "({{length}}) fonctionnalité(s) multinumérique(s) supprimée(s) avec succès : {{list}}"
      },
      "cancel": {
        "workitemWarning": "Etes-vous sûr de vouloir passer à l'élément de travail - <1>{{workItemName}} </1> ?",
        "homeWarning": "Êtes-vous sûr de vouloir naviguer à partir de cette page?",
        "featureChangeWarning": "Êtes-vous sûr de vouloir passer à une autre fonctionnalité ?",
        "undoPropAssociationWarning": "Êtes-vous sûr de vouloir annuler vos modifications ?"
      },
      "refresh": "Vos modifications actuelles seront perdues lors de l’actualisation. Voulez-vous continuer?",
      "saveProcos": {
        "rulesFailedTopic": "Échec du traitement",
        "rulesFailed": "Page {{pageNo}} : {{rule}} règles <ruleIcon/>, {{property}} propriétés <propertyIcon/>",
        "batchStatus": "Sauvegarder ProCos - {{completedBatchesCount}} lot(s) terminés sur {{totalBatchCount}} lot(s).",
        "batchSuccess": "Tous les lot(s) ont réussi",
        "batchFailed": "Tous les lot(s) ont échoué",
        "batchPartialSuccess": "Un ou plusieurs lots ont échoué"
      },
      "validation": {
        "enumInvalid": "Une ou plusieurs valeurs de propriété sont invalides (surlignées en rouge). Veuillez les corriger avant d'enregistrer."
      }
    },
    "inActiveProduct": {
      "header": "Produit inactif",
      "message": "Aucun changement d'association de marché autorisé"
    },
    "success": {
      "create": "Créé avec succès !",
      "update": "Mis à jour avec succès !"
    },
    "fail": {
      "create": "La création a échoué !",
      "update": "La mise à jour a échoué !",
      "get": "Une erreur s'est produite. Impossible de récupérer les détails !"
    }
  },
  "request": {
    "success": "Demande placée avec succès",
    "failed": "La demande a échoué"
  }
}
